<div class="left-section">
  <h3-gen-ai-toolbar></h3-gen-ai-toolbar>
  <h3-floating-feedback-panel
    [style.top.px]="toolbarHeight + 1"
    [style.right.px]="scrollbarWidth"
  ></h3-floating-feedback-panel>
  <div class="scrollable-container">
    <ng-content select="[projection-location='header']"></ng-content>

    <div class="prompts-container">
      @for (prompt of sortedPrompts; track prompt.index) {
        <h3-prompt [prompt]="prompt"></h3-prompt>
      }
    </div>

    <ng-content select="[projection-location='footer']"></ng-content>
  </div>
</div>

<h3-side-panel
  [style.width.px]="objectListWidth"
  [style.--ursa--split-view-toolbar-height.px]="toolbarHeight"
></h3-side-panel>
